import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const AugustContext: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Innovative Solutions for Urban Challenges: The Rise of InfraTech in
						South Asia
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/KishlayaMisraHeadshot-UpL7WyGayNjf.jpg"
						alt="Kishlaya Misra"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Kishlaya Misra
							<Link
								href="https://www.linkedin.com/in/kishlayamisra/"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Senior Investment Officer, Asian Infrastructure Investment Bank
							(AIIB)
						</Text>

						<Link
							href="https://www.linkedin.com/in/kishlayamisra/"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						Asia’s cities are becoming denser and more populous, putting
						significant strain on urban infrastructure. Accelerating
						urbanization is leading to congestion, environmental degradation and
						a decrease in the quality of public services. These challenges are
						further exacerbated by climate change, forcing cities to reckon with
						unpredictable heatwaves and natural disasters. With public budgets
						already stretched thin, simply building more cannot address
						fundamental urban challenges. Greater efficiency and innovation are
						needed to take full advantage of existing infrastructure, reduce
						public spending, mobilize private capital and minimize disruption to
						everyday life.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Some technology companies are already stepping in to address these
						urban challenges. For example, viAct is developing artificial
						intelligence (AI) systems to enhance construction site safety.
						Flyability is creating drones to inspect water pipes with minimal
						downtime. GeoSig is implementing hardware to prepare high-rise
						buildings for potential earthquakes. In terms of environmental
						resilience, disaster response, and efficiency, the urban sector is
						benefiting significantly from technology innovation.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Across South Asia, startups are beginning to emerge with the sole
						aim of applying technology to historically overlooked infrastructure
						sectors such as energy, water and transport. AIIB refers to this
						important trend as InfraTech.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						While infrastructure is the foundation of economic prosperity, it
						has remained the least digitized sector, and more than half of all
						projects 1 are consistently over budget and delayed. Alarmingly,
						since the 1990s, construction has shown the lowest labor
						productivity growth 2 of all other sectors. Concerns about the high
						costs of implementing new technologies and the limited perceived
						returns have deterred investment in R&amp;D. As a result, funding
						for emerging companies focusing on the infrastructure sector has
						lagged significantly, creating a $1.6 trillion opportunity 3 to
						improve productivity through innovative technologies.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						At AIIB, we are supporting the application of technology to
						infrastructure via two avenues.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						First, AIIB is directly investing in innovative infrastructure
						technology. In 2023, AIIB launched the Venture Capital Investment
						Program for Green and Technology-Enabled Infrastructure, mobilizing
						$100 million in direct investment and $30 million for co-investment
						to support early-stage companies across our 109 approved members.
						AIIB aims to invest in 10-12 global VC funds under the VC Investment
						program.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						South Asia, despite global economic uncertainties, has shown strong
						venture capital investment potential. However, the region suffers
						from underrepresentation in VC funding, necessitating additional
						capital to close the funding gap. AIIB’s program is addressing this
						by backing innovative InfraTech startups and promoting sustainable
						infrastructure through small-scale VC funds. The VC program is vital
						for promoting innovation, addressing funding disparities, and
						driving sustainable infrastructure development in underrepresented
						regions.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						Second, AIIB is financing the adoption of InfraTech. Since our
						founding in 2016, AIIB has approved more than 250 projects amounting
						to over $50 billion. Through our experience with infrastructure
						developers and operators, technology companies and government
						ministries, we have realized that many clients are unaware of
						emerging technologies or do not have the capacity to source and
						implement them.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						We are addressing this information asymmetry with our new InfraTech
						Portal, a free public repository of solutions, case studies and
						technology providers. AIIB is bridging the information gap and
						supporting infrastructure owners and operators in adopting
						technology that can improve profitability and sustainability.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						The InfraTech Portal is particularly useful for emerging markets
						like India, as it supports technology companies in benchmarking
						against global best practices, helps investors identify emerging
						regional trends, and empowers infrastructure clients with latest
						market-sourcing insights. This integration not only helps technology
						companies find new clients and attracts foreign investment. It also
						fosters a more competitive market environment. The InfraTech Portal
						features more than 1,000 global technology providers, including
						several emerging Indian startups like the VTOL drone company BLUJ
						Aero and sustainable cooling company Ambiator.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						We invite VC firms focused on InfraTech to partner with AIIB and
						technology companies focused on infrastructure to share their
						solutions on the InfraTech Portal. Together, we can demonstrate the
						transformative power of next-generation technology in
						infrastructure, fostering innovation and efficiency across South
						Asia. By collaborating, we can bridge the funding and information
						gap, ensuring that infrastructure investors, owners and operators
						have access to the best technologies available.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer">
						To know more about Asian Infrastructure Investment Bank (AIIB),
						please click here-
						<Link
							href="https://www.infratechportal.org/publicIndex"
							target="_blank"
							fontWeight="700"
							ml="4px"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							https://www.infratechportal.org/publicIndex
						</Link>
					</Text>
				</Box>
			</Box>

			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
            connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default AugustContext;
